import styled, { css, keyframes } from 'styled-components';
import { AllieButton } from '../../../components/Buttons/Button';
import { AllieItem } from '../../../components/Item/Item';

const slideUp = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

const slideDown = keyframes`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
`;

export const BottomSheetContainer = styled.div<{ isOpen: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 9999;

  ${(props) =>
    props.isOpen
      ? css`
          animation: ${slideUp} 0.3s ease-out forwards;
        `
      : css`
          animation: ${slideDown} 0.3s ease-in forwards;
        `}
`;

export const BottomSheetContent = styled.div<{ isIOS?: boolean }>`
  display: grid;
  grid-template-rows: auto 1fr auto;
  max-height: ${({ isIOS }) =>
    isIOS ? 'calc(100dvh - 65px - var(--safe-area-inset-top, 0px))' : 'calc(100dvh - 75px)'};
  padding: 20px;
  box-sizing: border-box;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: 1px solid var(--allie-color-neutral-20);
`;

export const ScrollableContent = styled.div`
  overflow-y: auto;
  padding-bottom: 16px;
`;

export const Footer = styled.div`
  padding-top: 16px;
`;

export const CloseButton = styled(AllieButton)`
  --border-radius: var(--allie-radius-md);
  --width: 28px;
  --border-color: var(--allie-color-neutral-40);
  ion-icon {
    color: var(--allie-color-neutral-70);
    font-size: 20px;
  }
`;

export const ItemHeaderFilter = styled(AllieItem)`
  --inner-padding-start: 0;
  --inner-padding-end: 0;
  --padding-start: 0;
  --padding-end: 0;
`;

export const OptionsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--allie-spacing-md);
  flex: 1 1 0;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 20px;
  margin-bottom: 10px;
  font-size: 14px;
`;

export const ApplyButton = styled(AllieButton)``;

export const FilterButton = styled(AllieButton)`
  --border-radius: var(--allie-radius-md);
  --width: 24px;
  --height: 24px;
  ion-icon {
    color: var(--allie-color-neutral-70);
  }

  &:hover {
    --border-radius: var(--allie-radius-md);
  }
`;

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(18, 18, 18, 0.2);
  z-index: 9998;
`;
